import type { App } from 'vue'
import overTip from '@qs-plus/directive/overTip'
import toaster from '@/plugins/toaster'
import { ElTableColumn } from '@/plugins/element-ui'

export function installPlugins(app: App) {
  app.use(toaster)
  app.use(overTip)

  app.use(ElTableColumn)
}
